import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings.js";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV



const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 lg:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-6/12 mt-8 md:mt-0`,
  props.textOnLeft ? tw`md:mr-8 lg:mr-16 md:order-first` : tw`md:ml-8 lg:ml-16 md:order-last`,
]);

const Image = styled.div((props) => [
  `background-image: url("${props.knowImage}");`,
  tw`rounded bg-cover bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8`;

const Heading = tw(SectionHeading)`text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 mt-4`;

const Statistics = tw.div`mt-6 lg:mt-8 xl:mt-16 flex flex-wrap`;
const Statistic = tw.div`text-lg sm:text-2xl lg:text-3xl w-1/2 mt-4 lg:mt-10 text-center md:text-left`;
const Value = tw.div`font-bold text-[#0049AC]`;
const Key = tw.div`font-medium text-gray-700`;

export default ({ textOnLeft = false }) => {
  const [data, setData] = useState({
    knowImage: "https://images.pexels.com/photos/30337816/pexels-photo-30337816/free-photo-of-group-photo-at-historic-moroccan-landmark.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    knowTitle: "We have the best tour packages.",
    knowDescription:
      "Embark on unforgettable journeys with our meticulously curated tour packages, designed to offer the perfect balance of adventure, relaxation, and cultural exploration. Whether you're dreaming of a tropical beach escape, a romantic honeymoon, a thrilling wildlife safari, or a cultural immersion, we have something for every traveler.",
    statistics: [
      { key: "Tour Packages", value: "192" },
      { key: "Destinations", value: "479" },
      { key: "Hotels & Resorts", value: "2093" },
      { key: "Event & Activities", value: "256" },
    ],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTourStats = async () => {
      try {
        const response = await fetch(`${API_URL}/web/knowus/stats`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();
        if (result.header.resCode == 200 && result.data.length > 0) {
          setData({
            knowImage: result.data[0].knowImage || data.knowImage,
            knowTitle: result.data[0].knowTitle || data.knowTitle,
            knowDescription: result.data[0].knowDescription || data.knowDescription,
            statistics: result.data[0].statistics.length > 0 ? result.data[0].statistics : data.statistics,
          });
        }
      } catch (error) {
        console.error("Failed to fetch data, using default values.", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTourStats();
  }, []);

  if (loading) {
    return <div className="flex justify-center items-center h-screen text-xl">Loading...</div>;
  }

  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image knowImage={data.knowImage} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <Heading>{data.knowTitle}</Heading>
            <Description>{data.knowDescription}</Description>
            <Statistics>
              {data.statistics.map((statistic, index) => (
                <Statistic key={index}>
                  <Value>{statistic.value}</Value>
                  <Key>{statistic.key}</Key>
                </Statistic>
              ))}
            </Statistics>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
